import { SessionSummaryContent } from './types'

export const aiSummaryMock: SessionSummaryContent = {
    segments: [
        {
            index: 0,
            name: 'Initial exploration and login',
            start_event_id: 'f9b23206',
            end_event_id: '7dd0dbd0',
            meta: {
                duration: 129,
                duration_percentage: 0.04122722914669223,
                events_count: 26,
                events_percentage: 0.10038610038610038,
                key_action_count: 5,
                failure_count: 2,
            },
        },
        {
            index: 1,
            name: 'Analytics, subscription, and navigation',
            start_event_id: '91e2f7b9',
            end_event_id: 'fbad19c4',
            meta: {
                duration: 40,
                duration_percentage: 0.01278363694471077,
                events_count: 7,
                events_percentage: 0.02702702702702703,
                key_action_count: 3,
                failure_count: 1,
            },
        },
        {
            index: 2,
            name: 'Project creation with interruptions and publishing',
            start_event_id: 'd775711b',
            end_event_id: 'fbeb743a',
            meta: {
                duration: 379,
                duration_percentage: 0.12112496005113454,
                events_count: 72,
                events_percentage: 0.277992277992278,
                key_action_count: 4,
                failure_count: 1,
            },
        },
        {
            index: 3,
            name: 'Portfolio and project navigation',
            start_event_id: '5e93a74c',
            end_event_id: '926c66d3',
            meta: {
                duration: 64,
                duration_percentage: 0.020453819111537232,
                events_count: 19,
                events_percentage: 0.07335907335907337,
                key_action_count: 3,
                failure_count: 0,
            },
        },
        {
            index: 4,
            name: 'Notifications and featured profile engagement',
            start_event_id: '8e1cf06b',
            end_event_id: 'b3b282d3',
            meta: {
                duration: 193,
                duration_percentage: 0.06168104825822947,
                events_count: 3,
                events_percentage: 0.011583011583011582,
                key_action_count: 3,
                failure_count: 0,
            },
        },
        {
            index: 5,
            name: 'Second project creation attempt',
            start_event_id: 'b8ad8185',
            end_event_id: '5ea6ddb3',
            meta: {
                duration: 511,
                duration_percentage: 0.16331096196868009,
                events_count: 34,
                events_percentage: 0.13127413127413126,
                key_action_count: 3,
                failure_count: 0,
            },
        },
        {
            index: 6,
            name: 'Settings, profile, and review request navigation',
            start_event_id: '38015d5e',
            end_event_id: 'c88c1ead',
            meta: {
                duration: 242,
                duration_percentage: 0.07734100351550016,
                events_count: 14,
                events_percentage: 0.05405405405405406,
                key_action_count: 3,
                failure_count: 0,
            },
        },
        {
            index: 7,
            name: 'Completed review request flow',
            start_event_id: 'df9a1f4f',
            end_event_id: '622dafb9',
            meta: {
                duration: 102,
                duration_percentage: 0.032598274209012464,
                events_count: 10,
                events_percentage: 0.03861003861003861,
                key_action_count: 2,
                failure_count: 0,
            },
        },
        {
            index: 8,
            name: 'User menu and navigation with frustration',
            start_event_id: 'afe03615',
            end_event_id: '701a7cea',
            meta: {
                duration: 8,
                duration_percentage: 0.002556727388942154,
                events_count: 6,
                events_percentage: 0.023166023166023165,
                key_action_count: 2,
                failure_count: 1,
            },
        },
        {
            index: 9,
            name: 'Settings exploration and branding',
            start_event_id: '1cc000e4',
            end_event_id: '6c4cf127',
            meta: {
                duration: 62,
                duration_percentage: 0.019814637264301695,
                events_count: 16,
                events_percentage: 0.06177606177606178,
                key_action_count: 2,
                failure_count: 0,
            },
        },
        {
            index: 10,
            name: 'Analytics, discovery, and session close',
            start_event_id: '58e371a9',
            end_event_id: '538e0b05',
            meta: {
                duration: 595,
                duration_percentage: 0.19015659955257272,
                events_count: 9,
                events_percentage: 0.03474903474903475,
                key_action_count: 2,
                failure_count: 0,
            },
        },
    ],
    key_actions: [
        {
            segment_index: 0,
            events: [
                {
                    description: 'Attempted login via Google',
                    failure: false,
                    event_id: '2b0428bc',
                    timestamp: '2025-04-17T18:23:09.021000+00:00',
                    milliseconds_since_start: 24903,
                    window_id: '019644fd-28d9-744d-afc6-2a0bc812a2c3',
                    current_url: 'https://contra.com/log-in',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 4,
                },
                {
                    description: 'User identified and logged in',
                    failure: false,
                    event_id: '17a37cc2',
                    timestamp: '2025-04-17T18:23:16.883000+00:00',
                    milliseconds_since_start: 32765,
                    window_id: '019644fd-28d9-744d-afc6-2a0bc812a2c3',
                    current_url: 'https://contra.com/log-in',
                    event: '$identify',
                    event_type: null,
                    event_index: 5,
                },
                {
                    description: 'Explored discovery and profile features',
                    failure: false,
                    event_id: '0c270698',
                    timestamp: '2025-04-17T18:23:54.661000+00:00',
                    milliseconds_since_start: 70543,
                    window_id: '019644fd-28d9-744d-afc6-2a0bc812a2c3',
                    current_url: 'https://contra.com/independent/discovery',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 8,
                },
                {
                    description: 'Rageclick indicating frustration on discovery page',
                    failure: true,
                    event_id: '327a4bb7',
                    timestamp: '2025-04-17T18:23:55.533000+00:00',
                    milliseconds_since_start: 71415,
                    window_id: '019644fd-28d9-744d-afc6-2a0bc812a2c3',
                    current_url: 'https://contra.com/independent/discovery',
                    event: '$rageclick',
                    event_type: 'click',
                    event_index: 10,
                },
                {
                    description: 'Abandoned recommendation request form after partial completion',
                    failure: true,
                    event_id: '7dd0dbd0',
                    timestamp: '2025-04-17T18:24:55.132000+00:00',
                    milliseconds_since_start: 131014,
                    window_id: '019644fd-28d9-744d-afc6-2a0bc812a2c3',
                    current_url: 'https://contra.com/independent/request-recommendation',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 26,
                },
            ],
        },
        {
            segment_index: 1,
            events: [
                {
                    description: 'Navigated to analytics and explored Pro membership',
                    failure: false,
                    event_id: '91e2f7b9',
                    timestamp: '2025-04-17T18:24:59.600000+00:00',
                    milliseconds_since_start: 135482,
                    window_id: '019644fd-28d9-744d-afc6-2a0bc812a2c3',
                    current_url: 'https://contra.com/rana_sahil',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 27,
                },
                {
                    description: 'Initiated Contra Pro subscription flow',
                    failure: false,
                    event_id: '5d968968',
                    timestamp: '2025-04-17T18:25:32.641000+00:00',
                    milliseconds_since_start: 168523,
                    window_id: '019644ff-469e-7e07-aadf-08e307d99e16',
                    current_url: 'https://contra.com/independent/analytics',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 33,
                },
                {
                    description: 'Closed subscription modal without subscribing',
                    failure: true,
                    event_id: 'd6aedf9e',
                    timestamp: '2025-04-17T18:25:46.244000+00:00',
                    milliseconds_since_start: 182126,
                    window_id: '019644ff-469e-7e07-aadf-08e307d99e16',
                    current_url: 'https://contra.com/independent/analytics',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 36,
                },
            ],
        },
        {
            segment_index: 2,
            events: [
                {
                    description: 'Started new project creation',
                    failure: false,
                    event_id: 'd775711b',
                    timestamp: '2025-04-17T18:26:00.165000+00:00',
                    milliseconds_since_start: 196047,
                    window_id: '019644ff-469e-7e07-aadf-08e307d99e16',
                    current_url: 'https://contra.com/rana_sahil/work',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 45,
                },
                {
                    description: 'Attempted to import project content',
                    failure: false,
                    event_id: 'e1d75cbf',
                    timestamp: '2025-04-17T18:26:59.757000+00:00',
                    milliseconds_since_start: 255639,
                    window_id: '01964500-2b24-7c9f-a2de-e2e0e4785614',
                    current_url: 'https://contra.com/project/new',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 48,
                },
                {
                    description: 'Rageclicks and repeated attempts during project import',
                    failure: true,
                    event_id: '3de324fa',
                    timestamp: '2025-04-17T18:27:33.266000+00:00',
                    milliseconds_since_start: 289148,
                    window_id: '01964500-2b24-7c9f-a2de-e2e0e4785614',
                    current_url: 'https://contra.com/project/new',
                    event: '$rageclick',
                    event_type: 'click',
                    event_index: 52,
                },
                {
                    description: 'Published project after overcoming interruptions',
                    failure: false,
                    event_id: 'fbeb743a',
                    timestamp: '2025-04-17T18:32:19.994000+00:00',
                    milliseconds_since_start: 575876,
                    window_id: '01964500-2b24-7c9f-a2de-e2e0e4785614',
                    current_url: 'https://contra.com/project/new',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 117,
                },
            ],
        },
        {
            segment_index: 3,
            events: [
                {
                    description: 'Viewed all work and navigated portfolio projects',
                    failure: false,
                    event_id: '5e93a74c',
                    timestamp: '2025-04-17T18:32:46.205000+00:00',
                    milliseconds_since_start: 602087,
                    window_id: '01964500-2b24-7c9f-a2de-e2e0e4785614',
                    current_url: 'https://contra.com/p/AogMv6No-pull-and-pour?justPublished=true&justUpdated=false',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 120,
                },
                {
                    description: 'Explored projects and invoices section',
                    failure: false,
                    event_id: '715c8939',
                    timestamp: '2025-04-17T18:33:36.315000+00:00',
                    milliseconds_since_start: 652197,
                    window_id: '01964500-2b24-7c9f-a2de-e2e0e4785614',
                    current_url: 'https://contra.com/discover',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 137,
                },
                {
                    description: 'Started new project from projects section',
                    failure: false,
                    event_id: '926c66d3',
                    timestamp: '2025-04-17T18:33:50.972000+00:00',
                    milliseconds_since_start: 666854,
                    window_id: '01964500-2b24-7c9f-a2de-e2e0e4785614',
                    current_url: 'https://contra.com/independent/projects',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 139,
                },
            ],
        },
        {
            segment_index: 4,
            events: [
                {
                    description: 'Checked notifications',
                    failure: false,
                    event_id: '8e1cf06b',
                    timestamp: '2025-04-17T18:34:53.672000+00:00',
                    milliseconds_since_start: 729554,
                    window_id: '019644fd-28d9-744d-afc6-2a0bc812a2c3',
                    current_url: 'https://contra.com/rana_sahil',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 143,
                },
                {
                    description: 'Engaged with featured profile notification',
                    failure: false,
                    event_id: '597f3889',
                    timestamp: '2025-04-17T18:35:01.164000+00:00',
                    milliseconds_since_start: 737046,
                    window_id: '019644fd-28d9-744d-afc6-2a0bc812a2c3',
                    current_url: 'https://contra.com/rana_sahil',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 144,
                },
                {
                    description: 'Copied featured profile link',
                    failure: false,
                    event_id: 'ffa0d35c',
                    timestamp: '2025-04-17T18:37:47.287000+00:00',
                    milliseconds_since_start: 903169,
                    window_id: '019644fd-28d9-744d-afc6-2a0bc812a2c3',
                    current_url:
                        'https://contra.com/hire/hindi-speaking-nestjs-freelancers?featuredUserProfileId=WyJVc2VyUHJvZmlsZSIsMzUxODkwMjVd',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 145,
                },
            ],
        },
        {
            segment_index: 5,
            events: [
                {
                    description: 'Initiated second project creation',
                    failure: false,
                    event_id: 'b8ad8185',
                    timestamp: '2025-04-17T18:40:28.092000+00:00',
                    milliseconds_since_start: 1063974,
                    window_id: '019644ff-469e-7e07-aadf-08e307d99e16',
                    current_url: 'https://contra.com/rana_sahil/work',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 148,
                },
                {
                    description: 'Attempted to import project content',
                    failure: false,
                    event_id: '3dc063de',
                    timestamp: '2025-04-17T18:40:38.295000+00:00',
                    milliseconds_since_start: 1074177,
                    window_id: '0196450d-81c2-7dcc-88b6-16583f4ce3c4',
                    current_url: 'https://contra.com/project/new',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 151,
                },
                {
                    description: 'Published second project',
                    failure: false,
                    event_id: '5ea6ddb3',
                    timestamp: '2025-04-17T18:48:59.280000+00:00',
                    milliseconds_since_start: 1575162,
                    window_id: '0196450d-81c2-7dcc-88b6-16583f4ce3c4',
                    current_url: 'https://contra.com/project/new',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 182,
                },
            ],
        },
        {
            segment_index: 6,
            events: [
                {
                    description: 'Viewed project owner actions',
                    failure: false,
                    event_id: '38015d5e',
                    timestamp: '2025-04-17T18:49:06.128000+00:00',
                    milliseconds_since_start: 1582010,
                    window_id: '0196450d-81c2-7dcc-88b6-16583f4ce3c4',
                    current_url: 'https://contra.com/p/ePl3OmPo-inara-home-decor?justPublished=true&justUpdated=false',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 183,
                },
                {
                    description: 'Navigated to services and about sections',
                    failure: false,
                    event_id: '20a95b72',
                    timestamp: '2025-04-17T18:49:20.467000+00:00',
                    milliseconds_since_start: 1596349,
                    window_id: '0196450d-81c2-7dcc-88b6-16583f4ce3c4',
                    current_url: 'https://contra.com/rana_sahil',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 187,
                },
                {
                    description: 'Started new review request',
                    failure: false,
                    event_id: 'c88c1ead',
                    timestamp: '2025-04-17T18:53:08.939000+00:00',
                    milliseconds_since_start: 1824821,
                    window_id: '0196450d-81c2-7dcc-88b6-16583f4ce3c4',
                    current_url: 'https://contra.com/rana_sahil/reviews',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 197,
                },
            ],
        },
        {
            segment_index: 7,
            events: [
                {
                    description: 'Completed review request form',
                    failure: false,
                    event_id: 'df9a1f4f',
                    timestamp: '2025-04-17T18:53:12.089000+00:00',
                    milliseconds_since_start: 1827971,
                    window_id: '01964519-09f9-71e0-bf6b-68b76ab10008',
                    current_url: 'https://contra.com/independent/request-recommendation',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 198,
                },
                {
                    description: 'Submitted review request successfully',
                    failure: false,
                    event_id: '622dafb9',
                    timestamp: '2025-04-17T18:54:54.212000+00:00',
                    milliseconds_since_start: 1930094,
                    window_id: '01964519-09f9-71e0-bf6b-68b76ab10008',
                    current_url: 'https://contra.com/independent/request-recommendation',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 208,
                },
            ],
        },
        {
            segment_index: 8,
            events: [
                {
                    description: 'Accessed user menu and notifications',
                    failure: false,
                    event_id: 'afe03615',
                    timestamp: '2025-04-17T18:57:54.254000+00:00',
                    milliseconds_since_start: 2110136,
                    window_id: '01964519-09f9-71e0-bf6b-68b76ab10008',
                    current_url: 'https://contra.com/naveen_kumar51/about',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 212,
                },
                {
                    description: 'Rageclick on user menu indicating navigation frustration',
                    failure: true,
                    event_id: 'ba1fd904',
                    timestamp: '2025-04-17T18:58:02.746000+00:00',
                    milliseconds_since_start: 2118628,
                    window_id: '01964519-09f9-71e0-bf6b-68b76ab10008',
                    current_url: 'https://contra.com/naveen_kumar51/about',
                    event: '$rageclick',
                    event_type: 'click',
                    event_index: 217,
                },
            ],
        },
        {
            segment_index: 9,
            events: [
                {
                    description: 'Explored rewards, payout, and branding settings',
                    failure: false,
                    event_id: '1cc000e4',
                    timestamp: '2025-04-17T19:00:58.470000+00:00',
                    milliseconds_since_start: 2294352,
                    window_id: '01964519-09f9-71e0-bf6b-68b76ab10008',
                    current_url: 'https://contra.com/rana_sahil',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 231,
                },
                {
                    description: 'Managed branding and logo',
                    failure: false,
                    event_id: '572730b2',
                    timestamp: '2025-04-17T19:01:55.047000+00:00',
                    milliseconds_since_start: 2350929,
                    window_id: '01964519-09f9-71e0-bf6b-68b76ab10008',
                    current_url: 'https://contra.com/settings/branding',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 245,
                },
            ],
        },
        {
            segment_index: 10,
            events: [
                {
                    description: 'Viewed analytics and discovery',
                    failure: false,
                    event_id: '58e371a9',
                    timestamp: '2025-04-17T19:02:03.058000+00:00',
                    milliseconds_since_start: 2358940,
                    window_id: '01964519-09f9-71e0-bf6b-68b76ab10008',
                    current_url: 'https://contra.com/settings/subscription',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 249,
                },
                {
                    description: 'Session ended after viewing featured profile modal',
                    failure: false,
                    event_id: '538e0b05',
                    timestamp: '2025-04-17T19:11:58.767000+00:00',
                    milliseconds_since_start: 2954649,
                    window_id: '0196450d-81c2-7dcc-88b6-16583f4ce3c4',
                    current_url:
                        'https://contra.com/hire/hindi-speaking-nestjs-freelancers?featuredUserProfileId=WyJVc2VyUHJvZmlsZSIsMzUxODkwMjVd',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 258,
                },
            ],
        },
    ],
    segment_outcomes: [
        {
            segment_index: 0,
            summary: 'User logged in but experienced frustration and abandoned a review request form.',
            success: false,
        },
        {
            segment_index: 1,
            summary: 'Explored analytics and subscription but abandoned Contra Pro upgrade after closing modal.',
            success: false,
        },
        {
            segment_index: 2,
            summary: 'Created and published a project despite interruptions and initial frustration.',
            success: true,
        },
        {
            segment_index: 3,
            summary: 'Successfully navigated portfolio and project sections, starting a new project.',
            success: true,
        },
        {
            segment_index: 4,
            summary: 'Engaged with notifications and featured profile, copied profile link.',
            success: true,
        },
        { segment_index: 5, summary: 'Successfully created and published a second project.', success: true },
        { segment_index: 6, summary: 'Explored profile and services, initiated a new review request.', success: true },
        { segment_index: 7, summary: 'Completed and submitted a review request form successfully.', success: true },
        {
            segment_index: 8,
            summary: 'Experienced navigation frustration in user menu with rageclicks.',
            success: false,
        },
        {
            segment_index: 9,
            summary: 'Explored and managed various settings including branding and logo.',
            success: true,
        },
        {
            segment_index: 10,
            summary: 'Viewed analytics, discovery, and ended session after featured profile engagement.',
            success: true,
        },
    ],
    session_outcome: {
        description:
            'User successfully created projects, submitted a review request, and explored key features despite some frustration and abandoned flows.',
        success: true,
    },
}
